export const loadFlagTexture = (textureLoader) => {
  const flagColorTexture = textureLoader.load("textures/flag/flag.jpg");
  return {
    flagColorTexture,
  };
};
